document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.cfh-wrapper');
  if (!wrapper) return;

  const header = wrapper.querySelector('.cfh-header');
  const announcement = wrapper.querySelector('.cfh-announcement-bar');

  const setHeaderHeight = () => {
    let total = 0;
    if (announcement && announcement.offsetHeight > 0) {
      total += announcement.offsetHeight;
    }
    if (header) {
      total += header.offsetHeight;
    }
    document.documentElement.style.setProperty('--cfh-mobile-header-height', total + 'px');
  };
  setHeaderHeight();
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setHeaderHeight, 150);
  }, { passive: true });

  /* ---- Mobile drawer ---- */
  const drawer = wrapper.querySelector('.cfh-mobile-drawer');
  const openMenuBtns = wrapper.querySelectorAll('.cfh-mobile-menu-open');
  const closeMenuBtns = wrapper.querySelectorAll('.cfh-mobile-menu-close, .cfh-mobile-drawer-overlay');

  const openDrawer = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cfh-drawer-open');
    closeMobileSearch();
  };
  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cfh-drawer-open');
    wrapper.querySelectorAll('.cfh-mobile-submenu.is-active').forEach(el => el.classList.remove('is-active'));
    const mainMenu = wrapper.querySelector('[data-mobile-menu]');
    if (mainMenu) mainMenu.style.visibility = '';
  };

  openMenuBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  closeMenuBtns.forEach(btn => btn.addEventListener('click', closeDrawer));

  /* ---- Desktop dropdown hover delay (mega + simple) ---- */
  const DESKTOP_DROPDOWN_MQ = window.matchMedia('(min-width: 1025px)');
  const DROPDOWN_CLOSE_DELAY = 280;
  const desktopDropdownItems = wrapper.querySelectorAll('.cfh-has-mega, .cfh-has-simple-dropdown');

  function closeAllDesktopDropdowns() {
    desktopDropdownItems.forEach((item) => {
      item.classList.remove('is-dropdown-open');
    });
  }

  function initDesktopDropdownHover() {
    desktopDropdownItems.forEach((item) => {
      if (item.dataset.cfhDropdownBound === '1') return;
      item.dataset.cfhDropdownBound = '1';

      const dropdown = item.querySelector('.cfh-mega-dropdown, .cfh-simple-dropdown');
      let closeTimer = null;

      const openDropdown = () => {
        if (!DESKTOP_DROPDOWN_MQ.matches) return;
        clearTimeout(closeTimer);
        closeTimer = null;
        item.classList.add('is-dropdown-open');
      };

      const scheduleClose = () => {
        if (!DESKTOP_DROPDOWN_MQ.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          item.classList.remove('is-dropdown-open');
        }, DROPDOWN_CLOSE_DELAY);
      };

      item.addEventListener('mouseenter', openDropdown);
      item.addEventListener('mouseleave', scheduleClose);

      if (dropdown) {
        dropdown.addEventListener('mouseenter', openDropdown);
        dropdown.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  initDesktopDropdownHover();
  DESKTOP_DROPDOWN_MQ.addEventListener('change', () => {
    if (!DESKTOP_DROPDOWN_MQ.matches) {
      closeAllDesktopDropdowns();
    }
  });

  wrapper.querySelectorAll('[data-submenu-trigger]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-submenu-trigger');
      const panel = wrapper.querySelector('[data-submenu="' + id + '"]');
      const mainMenu = wrapper.querySelector('[data-mobile-menu]');
      if (panel) {
        panel.hidden = false;
        panel.classList.add('is-active');
        if (mainMenu) mainMenu.style.visibility = 'hidden';
      }
    });
  });

  wrapper.querySelectorAll('[data-submenu-back]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.cfh-mobile-submenu');
      if (panel) {
        panel.classList.remove('is-active');
        setTimeout(() => { panel.hidden = true; }, 300);
      }
      const mainMenu = wrapper.querySelector('[data-mobile-menu]');
      if (mainMenu) mainMenu.style.visibility = '';
    });
  });

  const drawerSearchFocus = wrapper.querySelector('.cfh-drawer-search-focus');
  const drawerSearchInput = wrapper.querySelector('.cfh-drawer-search-input');
  if (drawerSearchFocus && drawerSearchInput) {
    drawerSearchFocus.addEventListener('click', () => drawerSearchInput.focus());
  }

  /* ---- Mobile search panel ---- */
  const mobileSearch = wrapper.querySelector('.cfh-mobile-search');
  const openSearchBtns = wrapper.querySelectorAll('.cfh-mobile-search-open');
  const mobileSearchInput = document.getElementById('cfh-mobile-search-input');
  const mobileClearBtn = document.getElementById('cfh-mobile-search-clear');
  const mobileDefault = document.getElementById('cfh-mobile-default');
  const mobileDynamic = document.getElementById('cfh-mobile-dynamic');
  const mobileHeading = document.getElementById('cfh-mobile-heading');
  let mobileDebounce;

  const openMobileSearch = () => {
    closeDrawer();
    setHeaderHeight();
    mobileSearch.classList.add('is-open');
    mobileSearch.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cfh-search-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => mobileSearchInput && mobileSearchInput.focus(), 150);
  };
  const closeMobileSearch = () => {
    if (!mobileSearch) return;
    mobileSearch.classList.remove('is-open');
    mobileSearch.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cfh-search-open');
    document.body.style.overflow = '';
  };

  const toggleMobileSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (mobileSearch.classList.contains('is-open')) {
      closeMobileSearch();
    } else {
      openMobileSearch();
    }
  };

  openSearchBtns.forEach(btn => btn.addEventListener('click', toggleMobileSearch));

  document.addEventListener('click', (e) => {
    if (!mobileSearch || !mobileSearch.classList.contains('is-open')) return;
    const insideSearch = e.target.closest('.cfh-mobile-search');
    const insideHeader = e.target.closest('.cfh-header') || e.target.closest('.cfh-announcement-bar');
    const isSearchBtn = e.target.closest('.cfh-mobile-search-open');
    if (!insideSearch && !insideHeader && !isSearchBtn) {
      closeMobileSearch();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileSearch && mobileSearch.classList.contains('is-open')) {
      closeMobileSearch();
    }
  });

  function buildCardHTML(product) {
    const price = product.price || '';
    const compare = product.compare_at_price || '';
    let priceHTML = '<span class="cfh-figma-price">' + price + '</span>';
    let saveBadge = '';
    const rawP = parseFloat(String(price).replace(/[^0-9.]/g, ''));
    const rawC = compare ? parseFloat(String(compare).replace(/[^0-9.]/g, '')) : 0;
    if (rawC > rawP) {
      const save = Math.round(((rawC - rawP) / rawC) * 100);
      priceHTML += '<span class="cfh-figma-compare">' + compare + '</span>';
      saveBadge = '<span class="cfh-figma-save">SAVE ' + save + '%</span>';
    }
    const star = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#facc15" stroke="#facc15"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    return '<div class="cfh-mobile-card"><a href="' + product.url + '" class="cfh-figma-card"><div class="cfh-figma-img"><img src="' + product.image + '" alt="' + product.title + '"></div><div class="cfh-figma-info"><div class="cfh-figma-stars">' + star + star + star + star + star + '<span class="cfh-stars-text">5.0</span></div><div class="cfh-figma-title">' + product.title + '</div><div class="cfh-figma-price-row">' + priceHTML + '</div>' + saveBadge + '</div></a></div>';
  }

  function resetMobileSearch() {
    if (mobileClearBtn) mobileClearBtn.style.display = 'none';
    if (mobileHeading) mobileHeading.textContent = 'FEATURED PRODUCTS';
    if (mobileDynamic) { mobileDynamic.style.display = 'none'; mobileDynamic.innerHTML = ''; }
    if (mobileDefault) mobileDefault.style.display = 'grid';
  }

  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('input', function() {
      const q = this.value.trim();
      if (q.length > 0) {
        if (mobileClearBtn) mobileClearBtn.style.display = 'block';
        if (mobileHeading) mobileHeading.textContent = 'SEARCH RESULTS';
        clearTimeout(mobileDebounce);
        mobileDebounce = setTimeout(() => {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
            .then(r => r.json())
            .then(data => {
              const products = data.resources.results.products || [];
              if (!mobileDynamic || !mobileDefault) return;
              if (products.length) {
                mobileDynamic.innerHTML = products.map(buildCardHTML).join('');
                mobileDefault.style.display = 'none';
                mobileDynamic.style.display = 'grid';
              } else {
                mobileDynamic.innerHTML = '<p style="grid-column:1/-1;color:#666;font-size:14px;">No products found.</p>';
                mobileDefault.style.display = 'none';
                mobileDynamic.style.display = 'grid';
              }
            });
        }, 300);
      } else {
        resetMobileSearch();
      }
    });
  }

  if (mobileClearBtn && mobileSearchInput) {
    mobileClearBtn.addEventListener('click', () => {
      mobileSearchInput.value = '';
      mobileSearchInput.focus();
      resetMobileSearch();
    });
  }

  /* ---- Desktop search modal ---- */
  const searchTrigger = wrapper.querySelector('.cfh-search-trigger');
  const searchModal = wrapper.querySelector('.cfh-search-modal');
  const searchClosers = wrapper.querySelectorAll('.cfh-search-close');
  const searchInput = document.getElementById('cfh-dynamic-input');
  const clearBtn = document.getElementById('cfh-search-clear');
  const defaultResults = document.getElementById('cfh-default-results');
  const dynamicResults = document.getElementById('cfh-dynamic-results');
  const headingText = document.getElementById('cfh-search-heading-text');
  let debounceTimer;

  function closeDesktopSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-active');
    document.body.classList.remove('cfh-desktop-search-open');
    document.body.style.overflow = '';
    resetDesktopSearch();
  }

  function openDesktopSearch(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!searchModal) return;
    closeAllDesktopDropdowns();
    searchModal.classList.add('is-active');
    document.body.classList.add('cfh-desktop-search-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }

  if (searchTrigger && searchModal) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (searchModal.classList.contains('is-active')) {
        closeDesktopSearch();
      } else {
        openDesktopSearch(e);
      }
    });

    searchClosers.forEach(c => c.addEventListener('click', (e) => {
      e.preventDefault();
      closeDesktopSearch();
    }));

    document.addEventListener('click', (e) => {
      if (!searchModal.classList.contains('is-active')) return;
      const insideContent = e.target.closest('.cfh-search-content');
      const onTrigger = e.target.closest('.cfh-search-trigger');
      if (!insideContent && !onTrigger) {
        closeDesktopSearch();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('is-active')) {
        closeDesktopSearch();
      }
    });
  }

  function resetDesktopSearch() {
    if (clearBtn) clearBtn.style.display = 'none';
    if (headingText) headingText.textContent = 'FEATURED PRODUCTS';
    if (dynamicResults) { dynamicResults.style.display = 'none'; dynamicResults.innerHTML = ''; }
    if (defaultResults) defaultResults.style.display = 'grid';
  }

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = this.value.trim();
      if (query.length > 0) {
        if (clearBtn) clearBtn.style.display = 'block';
        if (headingText) headingText.textContent = 'SEARCH RESULTS';
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=3')
            .then(r => r.json())
            .then(data => {
              const products = data.resources.results.products || [];
              if (!dynamicResults || !defaultResults) return;
              if (products.length) {
                dynamicResults.innerHTML = products.map(buildCardHTML).join('');
                defaultResults.style.display = 'none';
                dynamicResults.style.display = 'grid';
              } else {
                dynamicResults.innerHTML = '<p style="grid-column:1/-1;color:#666;">No products found.</p>';
                defaultResults.style.display = 'none';
                dynamicResults.style.display = 'grid';
              }
            });
        }, 300);
      } else {
        resetDesktopSearch();
      }
    });
    if (clearBtn) clearBtn.addEventListener('click', () => { searchInput.value = ''; searchInput.focus(); resetDesktopSearch(); });
  }

  /* ---- Hide header when theme cart drawer opens (mobile) — lightweight ---- */
  let cartIsOpen = false;
  let cartSyncTimer = null;
  const cartDrawerSelectors = 'cart-drawer, #cart-drawer, .cart-drawer, #CartDrawer';

  function isCartDrawerOpen(el) {
    if (!el) return false;
    return el.classList.contains('active') || el.classList.contains('is-open') || el.classList.contains('open') ||
      el.classList.contains('drawer--is-open') || el.hasAttribute('open') || el.getAttribute('aria-hidden') === 'false';
  }

  function syncCartOpenState() {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function() {
      if (!window.matchMedia('(max-width: 1024px)').matches) {
        if (cartIsOpen) {
          cartIsOpen = false;
          document.body.classList.remove('cfh-cart-open');
        }
        return;
      }
      const cartEl = document.querySelector(cartDrawerSelectors);
      const open = isCartDrawerOpen(cartEl);
      if (open === cartIsOpen) return;
      cartIsOpen = open;
      document.body.classList.toggle('cfh-cart-open', open);
      if (open) {
        closeDrawer();
        closeMobileSearch();
      }
    }, 80);
  }

  function watchCartDrawer() {
    const cartEl = document.querySelector(cartDrawerSelectors);
    if (!cartEl || cartEl.dataset.cfhWatched) return;
    cartEl.dataset.cfhWatched = '1';
    new MutationObserver(syncCartOpenState).observe(cartEl, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden']
    });
  }

  watchCartDrawer();
  window.addEventListener('load', watchCartDrawer, { once: true });

  wrapper.querySelectorAll('[data-cart-sidebar], [data-ajax-cart], #cart-icon-bubble').forEach(function(btn) {
    btn.addEventListener('click', syncCartOpenState, { passive: true });
  });

  document.addEventListener('cart:open', syncCartOpenState, { passive: true });
  document.addEventListener('cart:close', syncCartOpenState, { passive: true });

  /* ---- Cart bubble: listen once to theme cart-update (no observers / no polling) ---- */
  let lastCartCount = null;

  function renderCartCount(itemCount) {
    const count = Math.max(0, parseInt(itemCount, 10) || 0);
    if (count === lastCartCount) return;
    lastCartCount = count;

    const displayText = count >= 100 ? '99+' : String(count);
    document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach((node) => {
      node.textContent = displayText;
      const bubble = node.closest('.cart-count-bubble');
      if (bubble) bubble.classList.toggle('hidden', count <= 0);
    });
  }

  document.addEventListener('cart-update', (event) => {
    const count = event?.detail?.item_count;
    if (typeof count === 'number') renderCartCount(count);
  });
});

/* ---- Sticky mobile header ------------------------------------------------
   The announcement bar and the header are separate header-group sections, so
   they stick as two independent boxes. Both would pin at top: 0 and cover one
   another, so measure them in DOM order and give each its own offset. Heights
   change with viewport width and message length, so re-measure rather than
   hardcode. Paired with the sticky rules in cfh-header.css.            */
(function () {
  const SELECTOR = '.shopify-section-group-header-group';
  const mq = window.matchMedia('(max-width: 1024px)');
  let observer = null;

  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function layout() {
    const nodes = sections();

    if (!mq.matches) {
      nodes.forEach((el) => {
        el.style.top = '';
        el.style.zIndex = '';
      });
      document.documentElement.style.removeProperty('--bb-sticky-header-h');
      return;
    }

    let offset = 0;
    nodes.forEach((el, i) => {
      // floor the offset so a fractional height overlaps by a hair rather
      // than leaving a sliver of the page showing between the two bars
      el.style.top = Math.floor(offset) + 'px';
      // sticky makes each section a stacking context, so the z-index has to
      // stay put even when the section measures 0 -- opening the mobile drawer
      // hides .cfh-header, and without a z-index here the drawer (which lives
      // inside this section) drops behind the page content
      el.style.zIndex = String(1000 + i);
      offset += el.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--bb-sticky-header-h', Math.ceil(offset) + 'px');
  }

  function refresh() {
    if (observer) observer.disconnect();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(layout);
      sections().forEach((el) => observer.observe(el));
    }
    layout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('load', layout);
  window.addEventListener('resize', layout, { passive: true });
  window.addEventListener('orientationchange', layout);
  if (mq.addEventListener) mq.addEventListener('change', layout);
  else if (mq.addListener) mq.addListener(layout);

  // theme editor re-renders a section into a fresh node
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((evt) => {
    document.addEventListener(evt, refresh);
  });
})();
